import React from "react";
import Page from "../Components/Page";
import Timers from "../features/controls/timer/Timers";
import { useParams } from "react-router-dom";
import { ITimer } from "../features/controls/timer/types";
import useFetchData from "../hooks/useFetchData";
import { IControl } from "../features/controls/types";

export default function ControlPage() {
  const params = useParams();
  const { data: control, isLoading: isControlLoading } = useFetchData<IControl>(
    `/controls/${params.controlid}`,
  );
  const { data: timers, isLoading: isTimersLoading } = useFetchData<ITimer[]>(
    `/controls/${params.controlid}/timers`,
  );

  return (
    <Page isLoading={isControlLoading || isTimersLoading}>
      {control && timers && <Timers control={control} timers={timers} />}
    </Page>
  );
}
